/* tslint:disable */
/* eslint-disable */
/**
 * Cerebral Machines API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DictionaryEntryCreate } from '../models';
// @ts-ignore
import type { ValidationErrorModel } from '../models';
/**
 * DictionaryApi - axios parameter creator
 */
export const DictionaryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new dictionary term
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryCreatePost: async (dictionaryEntryCreate: DictionaryEntryCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dictionaryEntryCreate' is not null or undefined
            assertParamExists('dictionaryCreatePost', 'dictionaryEntryCreate', dictionaryEntryCreate)
            const localVarPath = `/api/dictionaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionaryEntryCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a dictionary term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryDeleteTermIdDelete: async (termId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('dictionaryDeleteTermIdDelete', 'termId', termId)
            const localVarPath = `/api/dictionaries/{term_id}`
                .replace(`{${"term_id"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a dictionary term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetTermIdGet: async (termId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('dictionaryGetTermIdGet', 'termId', termId)
            const localVarPath = `/api/dictionaries/{term_id}`
                .replace(`{${"term_id"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all dictionary terms
         * @param {string | null} [search] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryListGet: async (search?: string | null, limit?: number | null, offset?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dictionaries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a dictionary term by ID
         * @param {string} termId 
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryUpdateTermIdPut: async (termId: string, dictionaryEntryCreate: DictionaryEntryCreate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termId' is not null or undefined
            assertParamExists('dictionaryUpdateTermIdPut', 'termId', termId)
            // verify required parameter 'dictionaryEntryCreate' is not null or undefined
            assertParamExists('dictionaryUpdateTermIdPut', 'dictionaryEntryCreate', dictionaryEntryCreate)
            const localVarPath = `/api/dictionaries/{term_id}`
                .replace(`{${"term_id"}}`, encodeURIComponent(String(termId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dictionaryEntryCreate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DictionaryApi - functional programming interface
 */
export const DictionaryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DictionaryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new dictionary term
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryCreatePost(dictionaryEntryCreate: DictionaryEntryCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DictionaryEntryCreate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryCreatePost(dictionaryEntryCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryCreatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a dictionary term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryDeleteTermIdDelete(termId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryDeleteTermIdDelete(termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryDeleteTermIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a dictionary term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryGetTermIdGet(termId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryGetTermIdGet(termId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryGetTermIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List all dictionary terms
         * @param {string | null} [search] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryListGet(search?: string | null, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryListGet(search, limit, offset, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryListGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a dictionary term by ID
         * @param {string} termId 
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dictionaryUpdateTermIdPut(termId: string, dictionaryEntryCreate: DictionaryEntryCreate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dictionaryUpdateTermIdPut(termId, dictionaryEntryCreate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DictionaryApi.dictionaryUpdateTermIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DictionaryApi - factory interface
 */
export const DictionaryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DictionaryApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new dictionary term
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryCreatePost(dictionaryEntryCreate: DictionaryEntryCreate, options?: RawAxiosRequestConfig): AxiosPromise<DictionaryEntryCreate> {
            return localVarFp.dictionaryCreatePost(dictionaryEntryCreate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a dictionary term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryDeleteTermIdDelete(termId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryDeleteTermIdDelete(termId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a dictionary term by ID
         * @param {string} termId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryGetTermIdGet(termId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryGetTermIdGet(termId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all dictionary terms
         * @param {string | null} [search] 
         * @param {number | null} [limit] 
         * @param {number | null} [offset] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryListGet(search?: string | null, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryListGet(search, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a dictionary term by ID
         * @param {string} termId 
         * @param {DictionaryEntryCreate} dictionaryEntryCreate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dictionaryUpdateTermIdPut(termId: string, dictionaryEntryCreate: DictionaryEntryCreate, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dictionaryUpdateTermIdPut(termId, dictionaryEntryCreate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DictionaryApi - object-oriented interface
 */
export class DictionaryApi extends BaseAPI {
    /**
     * 
     * @summary Create a new dictionary term
     * @param {DictionaryEntryCreate} dictionaryEntryCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryCreatePost(dictionaryEntryCreate: DictionaryEntryCreate, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryCreatePost(dictionaryEntryCreate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a dictionary term by ID
     * @param {string} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryDeleteTermIdDelete(termId: string, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryDeleteTermIdDelete(termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a dictionary term by ID
     * @param {string} termId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryGetTermIdGet(termId: string, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryGetTermIdGet(termId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all dictionary terms
     * @param {string | null} [search] 
     * @param {number | null} [limit] 
     * @param {number | null} [offset] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryListGet(search?: string | null, limit?: number | null, offset?: number | null, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryListGet(search, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a dictionary term by ID
     * @param {string} termId 
     * @param {DictionaryEntryCreate} dictionaryEntryCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dictionaryUpdateTermIdPut(termId: string, dictionaryEntryCreate: DictionaryEntryCreate, options?: RawAxiosRequestConfig) {
        return DictionaryApiFp(this.configuration).dictionaryUpdateTermIdPut(termId, dictionaryEntryCreate, options).then((request) => request(this.axios, this.basePath));
    }
}

